/**
 * Product style swatches Web Component.
 * Fetches sibling products sharing custom.parent_style and renders image swatches.
 * Used on PDP and injected into Fast Simon collection cards via FSHooks.
 */
const styleCache = new Map();

class ProductStyles extends HTMLElement {
  connectedCallback() {
    if (this._init) return;
    this._init = true;

    this.listEl = this.querySelector('.ProductStyle-swatch-list');
    if (!this.listEl) return;

    this.parent_style = this.listEl.dataset.parentStyle;
    this.product_type = this.listEl.dataset.productType;
    this.currentId = this.listEl.dataset.currentId;

    console.log('[ProductStyleList] connected', {
      parent_style: this.parent_style,
      product_type: this.product_type,
      currentId: this.currentId,
    });

    if (this.parent_style && this.product_type) {
      this.loadStyles();
    } else {
      console.warn('[ProductStyleList] missing parent_style or product_type — skip');
      this.hidden = true;
    }
  }

  cacheKey() {
    return `${this.parent_style}::${this.product_type}`;
  }

  async loadStyles() {
    const key = this.cacheKey();

    try {
      let htmlPromise = styleCache.get(key);
      if (!htmlPromise) {
        const url = `/search?q=${encodeURIComponent(this.product_type)}&view=${encodeURIComponent('parent-style')}&filter.v.m.custom.parent_style=${encodeURIComponent(this.parent_style)}`;
        console.log('[ProductStyleList] fetch', url);
        htmlPromise = fetch(url).then((response) => {
          if (!response.ok) throw new Error(response.statusText);
          return response.text();
        });
        styleCache.set(key, htmlPromise);
      } else {
        console.log('[ProductStyleList] cache hit', key);
      }

      const html = await htmlPromise;
      if (!html || !this.isConnected) {
        console.warn('[ProductStyleList] empty response or disconnected', { key });
        return;
      }
      this.render(html);
    } catch (error) {
      styleCache.delete(key);
      console.error('[ProductStyleList] fetch error', error);
      this.hidden = true;
    }
  }

  render(result) {
    const html = new DOMParser().parseFromString(result, 'text/html');
    const styleList = html.querySelector('.ProductStyle-result');
    if (!styleList) {
      console.warn('[ProductStyleList] no .ProductStyle-result in response');
      this.hidden = true;
      return;
    }

    const items = styleList.querySelectorAll('.ProductStyle-swatch-item');
    if (items.length < 2) {
      console.log('[ProductStyleList] hide (< 2 swatches)', {
        count: items.length,
        parent_style: this.parent_style,
      });
      this.hidden = true;
      return;
    }

    if (this.currentId) {
      const activeItem = styleList.querySelector(
        `.ProductStyle-swatch-item[data-variant-id="${this.currentId}"]`
      );
      if (activeItem) activeItem.classList.add('active');
    }

    this.listEl.innerHTML = styleList.innerHTML;
    this.hidden = false;
    console.log('[ProductStyleList] rendered', {
      count: items.length,
      parent_style: this.parent_style,
      product_type: this.product_type,
      currentId: this.currentId,
    });
  }
}

customElements.define('product-style-list', ProductStyles);
